import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GuardServiceGuard implements CanActivate {

  token;
  constructor(private router: Router) { }

  // canActivate(
  //   next: ActivatedRouteSnapshot,
  //   state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
  //     // //your logic goes here
  //     if(this.token != undefined || this.token != null ){
  //       return true;
  //     }else{
  //         this.router.navigate(['home']);
  //         return false;
  //     }

  //   return true;
  // }
  canActivate(){
      // //your logic goes here
      if(this.token != undefined || this.token != null ){
        return true;
      }else{
          this.router.navigate(['home']);
          return false;
      }

  }
  
}
